import React from 'react';
import { Input, TextArea, Form } from 'semantic-ui-react';
import SubtypeDropDown from './SubtypeDropDown';
import TypeDropDown from './TypeDropDown';
import HangboardDropDown from './HangboardDropDown'
import '../style/generalForm.css';
import { WithTranslation, withTranslation } from 'react-i18next';
import IntensityTypeDropDown from './IntensityTypeDropDown';


interface GeneralFormProps extends WithTranslation{
    handleInputChanges: Function;
    errors: {title:boolean, subtype:boolean, intensityType:boolean};
    state: any;
}

const GeneralForm = (props: GeneralFormProps) => {
    const handleChanges = (e, { value, id }) => {
        props.handleInputChanges({ value: value, id: id });
    }
    const name = () =>
        <div>
            <h3>{props.t('title.title')}</h3>
            <Input value={props.state.title} id='inputTitle' fluid placeholder={props.t('placeholder.title')} maxLength='16' onChange={handleChanges} error={props.errors.title} />
        </div>
    const subtitle = () => {
        if (props.state.isAdmin)
            return (
                <div>
                    <h3>SubTitle</h3>
                    <Input id='inputSubtitle' placeholder='Enter the subtitle...' onChange={handleChanges} />
                </div>
            )
    }

    const img = () => {
        if (props.state.isAdmin) {
            return (
                <div>
                    <h3>Image</h3>
                    <Input id='inputImg' placeholder='Enter the local img address...' onChange={handleChanges} />
                </div>
            )
        }
    }

    const desc = () =>
        <div>
            <h3>{props.t('title.description')}</h3>
            <Form>
                <TextArea className='descriptionText' value={props.state.desc} id='inputDesc' fluid={true} placeholder={props.t('placeholder.description')} onChange={handleChanges} />
            </Form>
        </div>

    const type = () => {
        if (props.state.isAdmin)
            return (
                <div>
                    <h3>Workout type</h3>
                    <TypeDropDown handleChanges={handleChanges} id='workoutType' />
                </div>
            )
    }

    const subtype = () =>
        <div>
            <h3>{props.t('title.subtype')}</h3>
            <SubtypeDropDown value={props.state.subtype} handleChanges={handleChanges} error={props.errors.subtype} />
        </div>

    const hangboard = () =>
        <div>
            <h3>{props.t('title.hangboard')}</h3>
            <HangboardDropDown value={props.state.hangboard} handleChanges={handleChanges} />
        </div>

    const intensityType = () =>
        <div>
            <h3>{props.t('title.intensityType')}</h3>
            <IntensityTypeDropDown value={props.state.intensityType} handleChanges={handleChanges} />
        </div>

    return (
        <div className='form'>
            {name()}
            {subtitle()}
            {img()}
            {desc()}
            {type()}
            {subtype()}
            {hangboard()}
            {intensityType()}
        </div>)
}
    

export default withTranslation('exerciseCreator') (GeneralForm);